import cx from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";
import { IconModeOfTransportBike, Paragraph } from "@trainline/depot-web";
import * as styles from "./BikeReservation.module.css";
const BikeReservation = ({ bikeReservations }) => {
  return /* @__PURE__ */ React.createElement(Paragraph, {
    typeStyle: "mini",
    color: "subtle",
    as: "div",
    className: cx(styles.bikeReservations)
  }, /* @__PURE__ */ React.createElement(IconModeOfTransportBike, {
    className: cx(styles.bikeIcon)
  }), /* @__PURE__ */ React.createElement(FormattedMessage, {
    id: "transitLeg.bikeReservation",
    values: { reservations: bikeReservations.length }
  }), bikeReservations.length > 1 && /* @__PURE__ */ React.createElement("span", {
    className: styles.count
  }, "(", bikeReservations.length, ")"), /* @__PURE__ */ React.createElement("span", {
    className: cx(styles.spacer)
  }, "\u2022"), /* @__PURE__ */ React.createElement(FormattedMessage, {
    id: "transitLeg.bikeReservation.noAssignedSpace"
  }));
};
var BikeReservation_default = BikeReservation;
export {
  BikeReservation_default as default
};
